import styled from 'styled-components';
import { AlertTriangle } from 'lucide-react';

export const StyledAlertIcon = styled(AlertTriangle)`
  color: #EAB308;
  opacity: 0.9;
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
  transition: all 0.3s ease;
  margin-left: 2vw;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Card = styled.div`
  width: min(900px, calc(100vw - 40px));

  border-radius: 12px;
  border: 2px dashed #EAB308;;
  background: var(--surface-glass);
  box-shadow: var(--shadow-lg);

  padding: 1rem 1.5rem;
`;

export const TextBox = styled.div`
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.6;
  text-align: justify;
  font-weight: 300;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  letter-spacing: 0.3px;
  opacity: 0.9;
`;

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;